/* Rediseño Pants For Love · interacciones propias */
(function () {
  // Agregar al carrito desde tarjetas y combos, y abrir el drawer del tema
  async function agregar(items, btn) {
    if (btn) { btn.disabled = true; btn.classList.add('is-cargando'); }
    try {
      const r = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      });
      if (!r.ok) {
        const e = await r.json().catch(() => ({}));
        alert(e.description || 'No pudimos agregar este producto. Intenta de nuevo.');
        return;
      }
      document.dispatchEvent(new CustomEvent('cart:build'));
      document.dispatchEvent(new CustomEvent('cart:open'));
      if (btn) { btn.classList.add('is-ok'); setTimeout(() => btn.classList.remove('is-ok'), 1500); }
    } finally {
      if (btn) { btn.disabled = false; btn.classList.remove('is-cargando'); }
    }
  }
  window.pflAgregar = agregar;

  document.addEventListener('click', function (ev) {
    const b = ev.target.closest('[data-pfl-add]');
    if (!b) return;
    ev.preventDefault();
    const ids = String(b.dataset.pflAdd).split(',').filter(Boolean);
    agregar(ids.map((id) => ({ id: Number(id), quantity: 1 })), b);
  });

  // Cuenta regresiva: <div data-pfl-fin="2026-10-31T23:59:59-05:00"> con [data-d],[data-h],[data-m],[data-s]
  function tic() {
    document.querySelectorAll('[data-pfl-fin]').forEach(function (el) {
      const falta = new Date(el.dataset.pflFin) - new Date();
      if (isNaN(falta)) return;
      if (falta <= 0) { el.hidden = true; return; }
      const d = Math.floor(falta / 864e5), h = Math.floor(falta / 36e5) % 24,
        m = Math.floor(falta / 6e4) % 60, s = Math.floor(falta / 1e3) % 60;
      const pon = (k, v) => { const n = el.querySelector('[data-' + k + ']'); if (n) n.textContent = String(v).padStart(2, '0'); };
      pon('d', d); pon('h', h); pon('m', m); pon('s', s);
      el.hidden = false;
    });
  }
  tic();
  setInterval(tic, 1000);

  // ---------- Página de producto ----------
  const meta = document.querySelector('.product-single__meta');
  const varianteActual = () => {
    const f = meta && meta.querySelector('form[action*="/cart/add"] [name="id"]');
    return f ? Number(f.value) : null;
  };

  // Combo: agrega el producto actual + la opción elegida
  document.addEventListener('click', function (ev) {
    const b = ev.target.closest('[data-pfl-combo-add]');
    if (!b) return;
    const caja = b.closest('[data-pfl-combo]');
    const op = caja.querySelector('input[type=radio]:checked');
    const actual = varianteActual();
    if (!op || !actual) return;
    agregar([{ id: actual, quantity: 1 }, { id: Number(op.value), quantity: 1 }], b);
  });

  // Combo: total y ahorro en pesos según la opción elegida y la talla actual
  const plataC = (c) => '$' + Math.round(c / 100).toLocaleString('es-CO');
  function pintarCombo() {
    document.querySelectorAll('[data-pfl-combo]').forEach(function (caja) {
      const linea = caja.querySelector('[data-pfl-combo-total]');
      const op = caja.querySelector('input[type=radio]:checked');
      if (!linea || !op) return;
      let precios = {};
      try { precios = JSON.parse(caja.dataset.precios || '{}'); } catch (e) {}
      const actual = precios[varianteActual()] || Object.values(precios)[0];
      const otro = Number(op.dataset.precio);
      if (!actual || !otro) return;
      const lleno = actual + otro;
      const ahorro = Math.round(lleno * 0.1);
      linea.innerHTML = 'Combo: <s>' + plataC(lleno) + '</s> <b>' + plataC(lleno - ahorro) + '</b> · Ahorras ' + plataC(ahorro) + ' + envío gratis 🚚';
      linea.hidden = false;
    });
  }
  pintarCombo();
  const pintarComboLuego = () => setTimeout(pintarCombo, 120);
  document.addEventListener('change', pintarComboLuego);
  document.addEventListener('variant:change', pintarComboLuego);

  // Muestras de color: busca productos del mismo modelo
  function clave(titulo, tipo) {
    if (titulo.includes('+')) return null;
    const w = (titulo + ' ').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase()
      .replace(/[^a-z0-9 ]/g, ' ').split(/\s+/).filter(Boolean)
      .filter((x) => !['nuevo', 'nueva', 'pantalon', 'pant', 'bolso', 'edicion', 'especial', 'bag'].includes(x));
    // Todas las Banana Bags se muestran juntas: es el mismo bolso en distintos colores y telas
    if (w.includes('banana')) return { k: 'banana', q: 'banana bag' };
    const ty = (tipo || '').toLowerCase();
    let estilo = 'harem';
    if (w.includes('palazzo') || ty.includes('palazzo')) estilo = 'palazzo';
    else if (w.includes('boho') || ty.includes('boho')) estilo = 'boho';
    else if (w.includes('camiseta')) estilo = 'camiseta';
    const resto = w.filter((x) => !['harem', 'boho', 'palazzo', 'pants', 'camiseta', 'crop', 'top'].includes(x));
    let modelo = resto[0] || '';
    if (estilo === 'palazzo') modelo = resto[0] === 'silvestre' ? 'silvestre' : '';
    if (estilo === 'camiseta') modelo = '';
    return { k: estilo + '-' + modelo, q: modelo || estilo };
  }
  const caja = document.querySelector('[data-pfl-colores]');
  if (caja) {
    const yo = clave(caja.dataset.titulo, caja.dataset.tipo);
    if (yo) {
      fetch('/search?type=product&view=pfl-familia&q=' + encodeURIComponent(yo.q))
        .then((r) => r.text())
        .then((txt) => {
          const lista = JSON.parse(txt).filter((p) => { const c = clave(p.t, p.y); return c && c.k === yo.k; });
          if (lista.length < 2) return;
          lista.sort((a, b) => (b.u === caja.dataset.url) - (a.u === caja.dataset.url) || b.a - a.a);
          const cont = caja.querySelector('[data-lista]');
          lista.slice(0, 12).forEach((p) => {
            const a = document.createElement('a');
            a.href = p.u;
            a.className = 'pfl-colores__op' + (p.u === caja.dataset.url ? ' is-actual' : '') + (p.a ? '' : ' is-agotado');
            a.title = p.t.replace(/^(nuevo|nueva):\s*/i, '');
            if (p.i && p.i.startsWith('//') || (p.i && p.i.startsWith('http'))) {
              const img = document.createElement('img');
              img.src = p.i; img.alt = a.title; img.loading = 'lazy';
              a.appendChild(img);
            }
            cont.appendChild(a);
          });
          caja.hidden = false;
        })
        .catch(() => {});
    }
  }

  // Botón fijo de compra (reemplaza la app Sticky Add to Cart Bar)
  const sticky = document.querySelector('[data-pfl-sticky]');
  const btnPrincipal = meta && meta.querySelector('[data-add-to-cart]');
  if (sticky && btnPrincipal) {
    document.body.appendChild(sticky);
    const precio = meta.querySelector('[data-product-price]');
    const btn = sticky.querySelector('[data-pfl-sticky-btn]');
    const sincronizar = () => {
      if (precio) sticky.querySelector('[data-precio]').textContent = precio.textContent.trim();
      btn.disabled = btnPrincipal.disabled;
      btn.textContent = btnPrincipal.disabled ? 'Agotado' : 'Agregar al carrito';
    };
    new MutationObserver(sincronizar).observe(meta, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled'] });
    const revisar = () => {
      // En móvil también se muestra mientras el botón principal aún no aparece en pantalla
      const r = btnPrincipal.getBoundingClientRect();
      const visible = r.bottom < 0 || (window.innerWidth < 769 && r.top > window.innerHeight);
      if (visible === sticky.classList.contains('is-visible')) return;
      sticky.classList.toggle('is-visible', visible);
      sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
      document.body.classList.toggle('pfl-sticky-on', visible);
    };
    window.addEventListener('scroll', revisar, { passive: true });
    window.addEventListener('resize', revisar);
    revisar();
    btn.addEventListener('click', () => btnPrincipal.click());
    sincronizar();
  }
  // ---------- Carrito lateral: barra de envío gratis + sugerencia del combo ----------
  const envio = document.querySelector('[data-pfl-envio]');
  const upsell = document.querySelector('[data-pfl-upsell]');
  const plata = (c) => '$' + Math.round(c / 100).toLocaleString('es-CO');
  async function pintarCarrito() {
    let cart;
    try { cart = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json(); } catch (e) { return; }
    const titulos = cart.items.map((i) => ({ t: (i.product_title || '').toLowerCase(), y: (i.product_type || '').toLowerCase(), id: i.variant_id }));
    const hayBanana = titulos.some((i) => i.t.includes('banana'));
    const hayPant = titulos.some((i) => !i.t.includes('banana') && !i.t.includes('+') && (i.y.includes('pant') || i.y.includes('palazzo') || /pantal|palazzo|harem/.test(i.t)));
    const enPromo = Date.now() < Number(envio ? envio.dataset.fin : 0) * 1000;

    if (envio) {
      const meta = Number(envio.dataset.meta);
      const combo = enPromo && hayBanana && hayPant && cart.total_price >= 18000000;
      const falta = combo ? 0 : meta - cart.total_price;
      envio.hidden = cart.item_count === 0;
      envio.classList.toggle('is-ok', falta <= 0);
      envio.querySelector('[data-txt]').innerHTML = falta > 0
        ? 'Te faltan <b>' + plata(falta) + '</b> para el envío gratis 🚚'
        : combo ? '🎉 ¡Tu combo tiene <b>envío gratis</b>!' : '🎉 ¡Tu pedido tiene <b>envío gratis</b>!';
      envio.querySelector('[data-barra]').style.width = (combo ? 100 : Math.min(100, (cart.total_price / meta) * 100)) + '%';
      const ahorro = envio.querySelector('[data-pfl-ahorro]');
      if (ahorro) {
        if (cart.total_discount > 0) {
          ahorro.hidden = false;
          ahorro.innerHTML = 'Ahorraste <b>' + plata(cart.total_discount) + '</b> 🎉';
        } else if (enPromo && cart.item_count === 1 && hayPant) {
          ahorro.hidden = false;
          ahorro.innerHTML = 'Agrega una Banana Bag 🍌 y llévate <b>10% OFF + envío gratis</b>';
        } else if (enPromo && cart.item_count === 1 && hayBanana) {
          ahorro.hidden = false;
          ahorro.innerHTML = 'Agrega un pant 👖 y llévate <b>10% OFF + envío gratis</b>';
        } else {
          ahorro.hidden = true;
        }
      }
    }

    if (upsell) {
      const tipo = hayPant && !hayBanana ? 'banana' : hayBanana && !hayPant ? 'pant' : null;
      const lugar = upsell.querySelector('[data-lugar]');
      lugar.innerHTML = '';
      const enCarrito = new Set(titulos.map((i) => i.id));
      const ops = tipo ? [...upsell.querySelector('template').content.querySelectorAll('[data-tipo="' + tipo + '"]')]
        .filter((o) => !enCarrito.has(Number(o.dataset.id))).slice(0, 2) : [];
      upsell.hidden = ops.length === 0;
      if (!ops.length) return;
      upsell.querySelector('[data-tit]').innerHTML = tipo === 'banana'
        ? '🍌 Complétalo con una Banana Bag' + (enPromo ? ' <span>10% OFF + envío gratis</span>' : '')
        : '👖 Combínala con un pant' + (enPromo ? ' <span>10% OFF + envío gratis</span>' : '');
      ops.forEach((o) => {
        const n = o.cloneNode(true);
        if (tipo === 'banana' && enPromo) {
          const pr = Number(n.dataset.precio);
          n.querySelector('[data-precio-txt]').innerHTML = plata(pr * 0.9) + ' <s>' + plata(pr) + '</s>';
        }
        lugar.appendChild(n);
      });
    }
  }
  if (envio || upsell) {
    let espera;
    const programar = () => { clearTimeout(espera); espera = setTimeout(pintarCarrito, 150); };
    const productos = document.querySelector('#CartDrawer [data-products]');
    if (productos) new MutationObserver(programar).observe(productos, { childList: true, subtree: true });
    document.addEventListener('cart:updated', programar);
    document.addEventListener('ajaxProduct:added', programar);
    programar();
  }
})();

/* Bolita de video en la foto principal del producto: salta al video de la galería. */
(function () {
  const show = document.querySelector('.product-slideshow');
  const caja = document.querySelector('.product__main-photos');
  if (!show || !caja) return;
  const slideVid = [...show.querySelectorAll('.product-main-slide')].find(s => s.querySelector('.product__video-wrapper, video, iframe'));
  if (!slideVid) return;
  const idx = parseInt(slideVid.dataset.index, 10);
  const irAlVideo = () => {
    const f = window.Flickity && Flickity.data(show);
    if (f) f.select(idx);
    else { const t = document.querySelector('.product__thumb[data-index="' + idx + '"]'); if (t) t.click(); }
    setTimeout(() => { const v = slideVid.querySelector('video'); if (v && v.paused) { v.muted = true; v.play().catch(() => {}); } }, 400);
  };
  const b = document.createElement('button');
  b.type = 'button';
  b.className = 'pfl-vid-bolita pfl-vid-bolita--pdp';
  b.setAttribute('aria-label', 'Ver video del producto');
  b.innerHTML = '<span aria-hidden="true">▶</span>';
  b.addEventListener('click', e => { e.preventDefault(); e.stopPropagation(); irAlVideo(); });
  const primera = show.querySelector('.product-main-slide[data-index="0"] .product-image-main') || show.querySelector('.product-main-slide .product-image-main');
  if (!primera || primera.closest('.product-main-slide') === slideVid) return;
  primera.style.position = 'relative';
  primera.appendChild(b);
  ['pointerdown', 'mousedown', 'touchstart'].forEach(ev => b.addEventListener(ev, e => e.stopPropagation(), { passive: true }));
  const actualizar = () => {};
  if (location.hash === '#video') {
    setTimeout(() => { irAlVideo(); caja.scrollIntoView({ block: 'start', behavior: 'smooth' }); actualizar(); }, 700);
  }
})();

// Avísame cuando esté disponible (reemplaza Kbite): sale bajo "Agotado" y sigue la talla/color elegida.
(function () {
  const caja = document.querySelector('[data-pfl-aviso]');
  if (!caja) return;
  let disp = {};
  try { disp = JSON.parse(caja.dataset.disp); } catch (e) {}
  const meta = document.querySelector('.product-single__meta') || document;
  // Las tallas agotadas no tienen value en el select del tema: la variante sale del evento o de la URL.
  let elegida = new URLSearchParams(location.search).get('variant') || caja.dataset.inicial;
  let titulos = {};
  try { titulos = JSON.parse(caja.dataset.titulos); } catch (e) {}
  const actual = () => String(elegida || '');
  const nombreVar = (id) => titulos[id] || '';
  const form = caja.querySelector('[data-pfl-aviso-form]');
  const msg = caja.querySelector('[data-pfl-aviso-msg]');
  const pintar = () => {
    const id = actual();
    const agotada = disp[id] === 0;
    caja.hidden = !agotada;
    const n = agotada ? nombreVar(id) : '';
    caja.querySelector('[data-pfl-aviso-var]').textContent = n ? ' en ' + n : '';
    if (caja.dataset.listo && caja.dataset.listo !== id) { form.hidden = false; msg.textContent = ''; delete caja.dataset.listo; }
  };
  document.addEventListener('variant:change', (ev) => {
    const v = ev.detail && ev.detail.variant;
    if (v && v.id) elegida = v.id;
    setTimeout(pintar, 60);
  });
  meta.addEventListener('change', () => setTimeout(() => {
    elegida = new URLSearchParams(location.search).get('variant') || elegida;
    pintar();
  }, 120));
  pintar();

  form.addEventListener('submit', async (ev) => {
    ev.preventDefault();
    const datos = new FormData(form);
    const crudo = String(datos.get('celular') || '').trim();
    let cel = crudo.replace(/\D/g, '');
    const extranjero = crudo.startsWith('+') && !crudo.startsWith('+57');
    if (!extranjero && cel.startsWith('57') && cel.length === 12) cel = cel.slice(2);
    if (extranjero ? cel.length < 8 : !/^3\d{9}$/.test(cel)) { msg.textContent = 'Revisa el celular: deben ser 10 números y empezar por 3 (si es de otro país, escríbelo con + e indicativo).'; return; }
    const correo = String(datos.get('correo') || '').trim();
    if (correo && !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(correo)) { msg.textContent = 'Revisa el correo.'; return; }
    if (!datos.get('acepta')) { msg.textContent = 'Marca la casilla para que te podamos escribir.'; return; }
    const btn = form.querySelector('button');
    btn.disabled = true; msg.textContent = 'Guardando…';
    try {
      const r = await fetch(caja.dataset.endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          variante_id: actual(), producto_handle: caja.dataset.handle,
          celular: extranjero ? '+' + cel : '+57' + cel, correo: correo || null,
          nombre: String(datos.get('nombre') || '').trim() || null, acepta: true,
        }),
      });
      let res = {};
      try { res = await r.json(); } catch (e) {}
      if (!r.ok || !res.ok) {
        const textos = {
          hay_stock: 'Buenas noticias: esta talla ya está disponible 🎉 Recarga la página para comprarla.',
          celular_invalido: 'Revisa el celular, parece que tiene un error.',
          correo_invalido: 'Revisa el correo, parece que tiene un error.',
          sin_aceptar: 'Marca la casilla para que te podamos escribir.',
          demasiados_intentos: 'Hiciste muchos intentos seguidos. Prueba de nuevo en un rato.',
          demasiados_avisos: 'Ya tienes muchos avisos pendientes con este celular.',
        };
        msg.textContent = textos[res.error] || 'No pudimos guardarlo. Intenta de nuevo o escríbenos por WhatsApp.';
        return;
      }
      caja.dataset.listo = actual();
      form.reset(); form.hidden = true;
      msg.textContent = '';
      caja.querySelector('.pfl-aviso__sub').textContent = '¡Listo! 💚 Te escribimos por WhatsApp apenas vuelva.';
    } catch (e) {
      msg.textContent = 'No pudimos guardarlo. Intenta de nuevo o escríbenos por WhatsApp.';
    } finally { btn.disabled = false; }
  });
})();
